import { Injectable } from '@angular/core';
import { ControlType } from '../constants/control-type.enum';

// Arcgis components
import '@arcgis/map-components/components/arcgis-fullscreen';
import '@arcgis/map-components/components/arcgis-zoom';
import '@arcgis/map-components/components/arcgis-locate';
import '@arcgis/map-components/components/arcgis-placement';
import '@arcgis/map-components/components/arcgis-layer-list';
import '@arcgis/map-components/components/arcgis-expand';
import '@arcgis/map-components/components/arcgis-print';
import '@arcgis/map-components/components/arcgis-basemap-gallery';
import '@arcgis/map-components/components/arcgis-sketch';
import '@arcgis/map-components/components/arcgis-area-measurement-2d';
import '@arcgis/map-components/components/arcgis-distance-measurement-2d';
import '@arcgis/map-components/components/arcgis-coordinate-conversion';
import '@arcgis/map-components/components/arcgis-search';

import { MapControlItem } from '../constants/map-control-item.interface';

@Injectable()
export class ControlFactoryService {
	private _componentTag = new Map<ControlType, string>();
	constructor() {
		this._componentTag.set(ControlType.FullScreen, 'arcgis-fullscreen');
		this._componentTag.set(ControlType.Zoom, 'arcgis-zoom');
		this._componentTag.set(ControlType.Locate, 'arcgis-locate');
		this._componentTag.set(ControlType.Print, 'arcgis-print');
		this._componentTag.set(
			ControlType.BasemapGallery,
			'arcgis-basemap-gallery',
		);
		this._componentTag.set(ControlType.LayerList, 'arcgis-layer-list');
		this._componentTag.set(ControlType.DistanceMeasurement2D, 'arcgis-distance-measurement-2d');
		this._componentTag.set(ControlType.AreaMeasurement2D, 'arcgis-area-measurement-2d');
		this._componentTag.set(ControlType.Sketch, 'arcgis-sketch');
		this._componentTag.set(ControlType.CoordinateConversion, 'arcgis-coordinate-conversion');
		this._componentTag.set(ControlType.Search, 'arcgis-search');
	}

	createControl(controlConfig: MapControlItem) {
		if (this._componentTag.has(controlConfig.type)) {
			const tagName = this._componentTag.get(controlConfig.type);
			if (tagName) {
				const el = document.createElement(tagName) as any;
				el.id = `control-id-${controlConfig.type}`;
				el.position = controlConfig.position;
				if (controlConfig.attributes) {
					Object.assign(el, controlConfig.attributes);
				}
				return el;
			}
		}
		return null;
	}

	wrapExpand(options: any, control: any) {
		const expandEl = document.createElement('arcgis-expand') as any;
		Object.assign(expandEl, options);
		expandEl.appendChild(control);

		if (
			control.tagName === 'ARCGIS-AREA-MEASUREMENT-2D' ||
			control.tagName === 'ARCGIS-DISTANCE-MEASUREMENT-2D'
		) {
			const observer = new MutationObserver(() => {
				if (!expandEl.expanded && control.viewModel && typeof control.viewModel.clear === 'function') {
					control.viewModel.clear();
				}
			});
			observer.observe(expandEl, { attributes: true, attributeFilter: ['expanded'] });
		}
		return expandEl;
	}

	toggleButton(options: any, control: any, position: any) {
		const toogleEl = document.createElement('arcgis-placement') as any;
		toogleEl.position = position;
		Object.assign(toogleEl, options);
		const toggleButton = document.createElement('calcite-button') as any;
		toggleButton.kind = 'neutral';
		if (options.class) {
			toggleButton.classList.add(options.class);
		}
		if (options.iconStart) {
			toggleButton.setAttribute('icon-start', options.iconStart);
		}
		toogleEl.appendChild(toggleButton);
		return toogleEl;
	}
}
